import { useEffect, useState } from 'preact/hooks';

/**
 * Get current location's pathname and react to its changes
 */
export function usePathname() {
    const [pathname, setPathname] = useState<string>(location.pathname);

    useEffect(() => {
        const onPopstate = () => {
            setPathname(location.pathname);
        };
        window.addEventListener('popstate', onPopstate);
        return () => window.removeEventListener('popstate', onPopstate);
    }, []);

    return pathname;
}
